import { render, staticRenderFns } from "./RecentActivityTable.vue?vue&type=template&id=46d72eb8&"
import script from "./RecentActivityTable.vue?vue&type=script&lang=js&"
export * from "./RecentActivityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports